import { Vector } from "./vector";

export class Line {
  constructor(p1, p2) {
    if ((p1.x && p1.y && p2.x && p2.y) == undefined) {
      throw new Error("Incorrect points");
    }
    if (p1.x === p2.x && p1.y === p2.y) {
      throw new Error("Trying create line by 2 equal points");
    }

    this._p1 = p1;
    this._p2 = p2;
    this._A = p1.y - p2.y;
    this._B = p2.x - p1.x;
    this._C = p1.x * p2.y - p2.x * p1.y;
    this._k = null;
    this._b = null;
    if (this._B !== 0) {
      this._k = -this._A / this._B;
      this._b = -this._C / this._B;
    }
  }

  A() {
    return this._A;
  }
  B() {
    return this._B;
  }
  C() {
    return this._C;
  }

  p1() {
    return this._p1;
  }
  p2() {
    return this._p2;
  }

  normal_vector() {
    if (!this._normal_vector) {
      this._normal_vector = new Vector(this._A, this._B);
      this._normal_vector.normalize();
    }
    return this._normal_vector;
  }

  directing_vector() {
    if (!this._directing_vector) {
      this._directing_vector = new Vector(
        this.p2().x - this.p1().x,
        this.p2().y - this.p1().y
      );
      this._directing_vector.normalize();
    }
    return this._directing_vector;
  }

  intersection_point(line) {
    const det = this._A * line.B() - this._B * line.A();
    const det_x = -this._C * line.B() - this._B * -line.C();
    const det_y = this._A * -line.C() - -this._C * line.A();
    return { x: det_x / det, y: det_y / det };
  }
}
